/** @fileoverview Shares the app's themed element with parts that render in a portal, such as dialogs, so they keep the app's colours. */

import { createContext, useContext } from 'react';

/** The element that carries the app's theme, or null outside a themed app. */
export const ThemeContainerContext = createContext<HTMLElement | null>(null);

/** Gives the element that carries the app's theme, to render a dialog or popover inside it. */
export const useThemeContainer = () => useContext(ThemeContainerContext);
